import { reactive, ref } from 'vue';

const queryString = window.location.href;
export const url = new URL(queryString);

const currentPage = url.searchParams.get('p');
const currentCat = url.searchParams.get('c');
const currentView = url.searchParams.get('view');

const overviewGridElement = document.querySelector('[data-vpp]');

const options = {};

if (overviewGridElement) {
    const closestPane = overviewGridElement;
    options.vue_pp = closestPane.getAttribute('data-vpp');
}


export function slugify(str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim leading/trailing white space
    str = str.toLowerCase(); // convert string to lowercase
    str = str.replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, '-'); // remove consecutive hyphens
    return str;
}

export const state = reactive({
    loading: ref(true),
    pages: [],
    filteredPages: [],
    currentPage: parseInt(currentPage) ? parseInt(currentPage) : 1,
    view: currentView || 'grid',
    itemsPerPage: parseInt(options.vue_mpp) || 6,
    categories: [],
    selectedFilter: currentCat ? currentCat : 'all',
});

export function fetchPages() {
    const requestUrl = `${url.origin}/api/overview/${options.vue_pp}`;

    return fetch(requestUrl, {
        cache: 'default',
    })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            // Use the fetched data
            state.pages = data;
            state.filteredPages = data;
            state.loading = false;
        });
}

export function fetchCategories() {
    const requestUrl = `${url.origin}/api/categories/${options.vue_pp}`;

    return fetch(requestUrl, {
        cache: 'default',
    })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            state.categories = data;
        });
}
